import { render, staticRenderFns } from "./v-custom-numberByIcon.vue?vue&type=template&id=0ef10bf9&"
import script from "./v-custom-numberByIcon.vue?vue&type=script&lang=js&"
export * from "./v-custom-numberByIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
